"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokens = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
exports.tokens = require("./tokens");
//# sourceMappingURL=index.js.map